module.exports = function isFunction(x) {
  return typeof x === 'function';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isFunction.js
 ** module id = 46
 ** module chunks = 0
 **/